import { GroupId } from 'admin/groups/Groups';
import { ModuleId } from 'admin/modules/Modules';
import { DateRange } from 'core/util/DateRange';
import { Filter as SearchFilter } from 'core/util/Search';

export enum ObjectModel {
    Address = 'R4EAddress.address',
    Comment = 'R4EComment2.comment2',
    Customer = 'R4ECustomer.customer',
    EntityMetadata = 'R4EEntity.entityMetadata',
    Location = 'R4ELocation.location',
    Report = 'R4EReport.report',
    RequestTemplate = 'R4ERequest.requestTemplate',
    Survey3Result = 'R4ESurvey3.survey',
    Survey3Template = 'R4ESurvey3.survey_template',
    User = 'R4EUser.user',
    CustomerId = 'R4EComment2.comment2.customerID',
    Type = 'R4EComment2.comment2.type',
    AssignedToRoleId = 'R4EComment2.comment2.assignedToRoleID',
    AssignedToUserId = 'R4EComment2.comment2.assignedToUserID',
    AssignedToQueueId = 'R4EComment2.comment2.assignedToQueueID',
    Source = 'R4EEntity.entityMetadata.source',
    SearchInsights = 'R4EBLLocalSearchRankings.searchInsight',
    DueDate = 'R4EComment2.comment2.dueDate',
    StageId = 'R4EComment2.comment2.conversationMetadataStageID',
    Insight = 'R4EKeyword.insight',
    TicketDefinition = 'R4ETicket.ticket',
    ReviewCore = 'R4EComment2.reviewCore',
    AdvancedKeywordFilter = 'R4EFilter.filter.advancedFilter',
    Report2 = 'report2',
}

// unique name for page where saved views are being used
export enum PageId {
    Insights = 'insights',
    Reviews = 'reviews',
    Inbox = 'inbox',
}

export enum DataType {
    Long,
    String,
    Date,
    Double,
    ObjectId,
    Boolean,
    Clob,
    Integer,
    Email,
    GeoPoint,
    Map,
    List,
    Object,
    Enum,
}

export enum WidgetType {
    Text = 1,
    SingleSelect = 2,
    MultiSelect = 3,
    Date = 4,
    Toggle = 5,
}

export enum FilterName {
    Date = 'date',
    Source = 'source',
}

export interface FilterValue {
    value: string;
    label: string;
    selected?: boolean;
    group?: string;
    dateRange?: DateRange;
}

export interface FilterValues {
    values: FilterValue[];
    count: number;
}

export interface FilterDefinition {
    objectFieldName: string;
    name: string;
    label: string;
    group: string;
    dataType: DataType;
    widgetType: WidgetType;
    order: number;
    groupOrder: number;
    values: FilterValue[];
    valuesCount: number;
    extraOptions?: any;
    selected?: boolean;
    locked?: boolean;
    selectedValues?: any;
}

export interface GetFilterDefinitionsRequest {
    filterDefinitionID: string;
    moduleGroup: GroupId;
    objectModelName: ObjectModel;
    excluded?: string[];
    depth?: number;
    selectedFilters?: SearchFilter[];
    maxPageSize?: number;
}

export interface GetFilterDefinitionsArgs {
    key: string;
    moduleIDs?: ModuleId[];
    disabled?: string[];
    removed?: string[];
    hideFiltersWithOneValue?: boolean;
    includeValues?: boolean;
}

export interface GetFilterValuesRequest {
    name: string;
    objectFieldName: string;
    selectedFilters?: SearchFilter[];
    moduleIDs?: ModuleId[];
    start?: number;
    count?: number;
}

export interface AdvancedFilterRules {
    agencyID: number;
    name: string;
    id: string;
    rules: {
        query: {
            field: string;
            fieldKey: string;
            operator: number;
            valueString: string[];
        }[];
    }[];
}

export enum Operator {
    NotContains = 13,
    ContainsWord = 16,
}

export enum TextType {
    MentionText = 'Mentions Text',
}
